<template>
  <div class="carmanagementBody">
    <el-col style="margin-bottom: 10px">
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        "
      >
        <div style="flex-direction: column; width: fit-content">
          车牌号：
          <el-input
            placeholder="请输入车牌号"
            v-model="queryForm.carNum"
            style="width: 200px"
          ></el-input>
          车辆类型：
          <el-select
            placeholder="请选择车辆类型"
            v-model="carTypeTxt"
            style="width: 200px; margin-right: 10px"
          >
            <el-option
              v-for="item in this.carTypeList"
              :key="item.dictValue"
              :label="item.dictName"
              :value="item.dictName"
            >
            </el-option>
          </el-select>
          <el-button type="primary" @click="searchCarSubmit()">查询</el-button>
          <el-button @click="searchCarReSet()">重置</el-button>
        </div>

        <el-button type="primary" @click="openAddNewCarInfoDialog()"
          >新增车辆</el-button
        >
      </div>
    </el-col>

    <div class="tableContainer">
      <el-table
        v-loading="listLoading"
        :data="dataList"
        border
        fit
        highlight-current-row
      >
        <el-table-column
          label="车牌号"
          prop="carNum"
          width="200"
          align="left"
        />
        <el-table-column
          label="车辆类型"
          prop="carTypeName"
          width="120"
          align="center"
        />
        <el-table-column
          label="所属部门"
          prop="deptName"
          width="120"
          align="left"
        />
        <el-table-column
          label="所属班组"
          prop="groupName"
          width="150"
          align="left"
        />
        <el-table-column
          label="司机"
          prop="driverName"
          width="120"
          align="center"
        />
        <el-table-column
          label="车辆标识（设备IMEI）"
          prop="carNo"
          width="280"
          align="left"
        />
        <el-table-column
          label="可用状态"
          prop="usageStatus"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag
              :type="getUsageStatusTagString(scope.row.usageStatus)"
              class="change-state"
            >
              {{ usageStatusTag[scope.row.usageStatus] }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          label="定位"
          prop="cameraNo"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <el-link @click="openMap(scope.row.carNo)" target="_blank">
              <i class="el-icon-location-outline" />
            </el-link>
          </template>
        </el-table-column>

        <el-table-column
          label="保险到期"
          prop="endDate"
          width="130"
          align="center"
        >
          <template slot-scope="scope">
            <div v-show="scope.row.endDate != null">
              {{ scope.row.endDate }}到期
            </div>

            <div v-show="scope.row.company != null">
              {{ scope.row.company }}保险
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="上次保养信息"
          prop="repairDate"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <div v-show="scope.row.repairDate != null" style="font-size: 16px">
              {{ scope.row.repairDate }}
            </div>

            <div
              v-show="scope.row.distance != null"
              style="font-size: 14px; margin-top: 5px"
            >
              {{ scope.row.distance }}KM
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="待处理违章"
          prop="illegalCount"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <div
              v-show="scope.row.unDealNumber != null"
              style="font-size: 16px"
            >
              {{ scope.row.unDealNumber }}条
            </div>

            <div
              v-show="scope.row.dealNumber != null"
              style="font-size: 14px; margin-top: 5px"
            >
              {{ scope.row.dealNumber }}条已处理
            </div>
          </template>
        </el-table-column>

        <el-table-column label="二维码" align="center" width="80">
          <template slot-scope="scope">
            <el-popover
              v-show="scope.row.qrcodeUrl != null"
              placement="top"
              trigger="click"
            >
              <img
                :src="scope.row.qrcodeUrl"
                style="width: 200px; height: 230px"
                alt=""
              />
              <img
                slot="reference"
                :src="scope.row.qrcodeUrl"
                style="
                  width: 30px;
                  height: 34px;
                  cursor: pointer;
                  vertical-align: middle;
                "
                alt=""
              />
              <el-button
                type="text"
                size="small"
                @click="downloadQRCode(scope.row)"
                >下载</el-button
              >
            </el-popover>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="300">
          <template slot-scope="scope">
            <div
              style="
                display: flex;
                justify-content: space-around;
                align-items: center;
              "
            >
              <el-button
                type="text"
                size="small"
                @click="openCarRecordsInfoDialog(scope.row)"
                >使用记录</el-button
              >
              <div style="width: 10px"></div>
              <el-button
                type="text"
                size="small"
                @click="openCarInsuranceInfoDialog(scope.row)"
                >保险记录</el-button
              >
              <div style="width: 10px"></div>
              <el-button
                type="text"
                size="small"
                @click="openCarMaintenanceInfoDialog(scope.row)"
                >保养记录</el-button
              >
              <div style="width: 10px"></div>
              <el-button
                type="text"
                size="small"
                @click="openViolationViolationnfoDialog(scope.row)"
                >违章记录</el-button
              >
              <div style="width: 10px"></div>
              <el-button
                type="text"
                size="small"
                @click="openUpdateCarInfoDialog(scope.row)"
                >编辑</el-button
              >
              <div style="width: 10px"></div>
              <el-popconfirm
                title="确定删除该车辆吗？"
                @confirm="delCarInfoEvent(scope.row)"
              >
                <el-button
                  type="text"
                  size="small"
                  style="color: #f56c6c"
                  slot="reference"
                  >删除</el-button
                >
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!--页码-->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryForm.current"
        :limit.sync="queryForm.size"
        @pagination="getCarListPage"
      />
    </div>

    <!-- 添加车辆 -->
    <AddNewCarInfoDialog
      :addNewCarInfoDialogVisible="this.addNewCarInfoDialogVisible"
      :carTypeList="this.carTypeList"
      :organizatonData="this.organizatonData"
      :groupInfoList="this.groupInfoList"
      @afterSubmitEvent="getCarListPage()"
      @closeEvent="addCarInfoDialogClose()"
    />

    <!-- 车辆记录 -->
    <CarRecordsInfoDialog
      :carRecordsInfoDialogVisible="this.carRecordsInfoDialogVisible"
      :selectCarRecordsInfo="this.selectCarRecordsInfo"
      @closeEvent="carRecordsInfoDialogClose()"
    />

    <!-- 编辑车辆 -->
    <UpDateCarInfoDialog
      :updateCarInfoDialogVisible="this.updateCarInfoDialogVisible"
      :carTypeList="this.carTypeList"
      :organizatonData="this.organizatonData"
      :groupInfoList="this.groupInfoList"
      :selectCarUpdateInfo="this.selectCarUpdateInfo"
      @afterSubmitEvent="getCarListPage()"
      @closeEvent="updateCarInfoDialogClose()"
    />

    <!-- 违章弹窗 -->
    <ViolationRecordsInfoDialog
      :carViolationRecordsInfoDialogVisible="
        this.openViolationInfoDialogVisible
      "
      :selectCarInfo="this.selectCarViolationInfo"
      @closeEvent="violationInfoDialogClose()"
    />

    <!-- 车辆保养 -->
    <CarMaintenanceInfoDialog
      :carMaintenanceInfoDialogVisible="
        this.openCarMaintenanceInfoDialogVisible
      "
      :selectCarInfo="this.selectCarMaintenanceInfo"
      @closeEvent="carMaintenanceInfoDialogClose()"
    />

    <!-- -->
    <CarInsuranceInfoDialog
      :carInsuranceInfoDialogVisible="this.openCarInsuranceInfoDialogVisible"
      :selectCarInfo="this.selectCarInsuranceInfo"
      @closeEvent="carInsuranceInfoDialogClose()"
    />
  </div>
</template>

<style>
.carmanagementBody {
  width: auto;
  height: 100%;
  padding: 24px;
  overflow: hidden;
  overflow-y: auto;
}
</style>

<script>
import QRCode from "qrcode";
import Pagination from "@/components/PaginationStyle1.vue";
import {
  carDelete,
  carListPage,
  getDictList,
  urlDirect,
} from "@/api/equipmentmanagement";
import AddPeople from "@/components/AddPeople/index.vue";
import { getOrganizationList } from "@/api/pServer/staff";
import TeamGroupApi from "@/api/teamGroup";
import AddNewCarInfoDialog from "@/views/equipmentmanagement/dialog/AddNewCarInfoDialog.vue";
import CarRecordsInfoDialog from "@/views/equipmentmanagement/dialog/CarRecordsInfoDialog.vue";
import UpDateCarInfoDialog from "@/views/equipmentmanagement/dialog/UpDateCarInfoDialog.vue";
import ViolationRecordsInfoDialog from "@/views/equipmentmanagement/dialog/ViolationRecordsInfoDialog.vue";
import CarMaintenanceInfoDialog from "@/views/equipmentmanagement/dialog/CarMaintenanceInfoDialog.vue";
import CarInsuranceInfoDialog from "@/views/equipmentmanagement/dialog/CarInsuranceInfoDialog.vue";

export default {
  components: {
    CarInsuranceInfoDialog,
    CarMaintenanceInfoDialog,
    ViolationRecordsInfoDialog,
    UpDateCarInfoDialog,
    CarRecordsInfoDialog,
    AddNewCarInfoDialog,
    AddPeople,
    Pagination,
  },
  data() {
    return {
      carTypeList: [],
      organizatonData: [],
      carTypeTxt: "",

      groupInfoList: [],

      //查询
      listLoading: false,
      dataList: [],
      total: 0,
      queryForm: {
        current: 1,
        size: 10,
      },
      usageStatusTag: ["可使用", "使用中", "维修中"],

      //添加车辆
      addNewCarInfoDialogVisible: false,

      //车辆记录
      carRecordsInfoDialogVisible: false,
      selectCarRecordsInfo: {},

      //编辑
      updateCarInfoDialogVisible: false,
      selectCarUpdateInfo: {},

      //车辆违章
      openViolationInfoDialogVisible: false,
      selectCarViolationInfo: {},

      //车辆保养
      openCarMaintenanceInfoDialogVisible: false,
      selectCarMaintenanceInfo: {},

      //保险
      openCarInsuranceInfoDialogVisible: false,
      selectCarInsuranceInfo: {},
    };
  },
  methods: {
    async getDictList() {
      const result = await getDictList({ dictCode: "car_type" });
      this.carTypeList = result.data.data;
    },
    async getOrganizatonData() {
      getOrganizationList().then((res) => {
        if (res.data.code === 200) {
          this.organizatonData.push(res.data.data);
        }
      });
    },
    //获取班组
    async getGroupInfo() {
      TeamGroupApi.getGroupInfo().then((res) => {
        if (res.data.code === 200) {
          this.groupInfoList = res.data.data;
        }
      });
    },
    searchCarSubmit() {
      this.carTypeList.forEach((value, index) => {
        if (this.carTypeTxt === value.dictName) {
          this.queryForm.carType = value.dictValue;
          // console.log(value.dictValue)
        }
      });

      // console.log(this.queryForm)
      this.getCarListPage();
    },

    searchCarReSet() {
      this.carTypeTxt = "";
      this.queryForm = this.$options.data().queryForm;
      this.getCarListPage();
    },

    async getCarListPage() {
      this.listLoading = true;
      const res = await carListPage(this.queryForm);
      // console.log(res)
      const list = res.data.data.records;
      // 预初始化 qrcodeUrl，确保 Vue 2 响应式能追踪
      this.dataList = list.map((item) => ({
        ...item,
        qrcodeUrl: null,
      }));
      this.total = res.data.data.total;
      this.listLoading = false;
      // 生成二维码
      await this.generateQRCodes();
    },
    async generateQRCodes() {
      for (let i = 0; i < this.dataList.length; i++) {
        const row = this.dataList[i];
        if (row.carNo && row.carNum) {
          // const qrContent =
          //   process.env.VUE_APP_BASE_URL +
          //   "?carNo=" +
          //   encodeURIComponent(row.carNo || "") +
          //   "&carNum=" +
          //   encodeURIComponent(row.carNum || "") +
          //   "&carTypeName=" +
          //   encodeURIComponent(row.carTypeName || "");
          // 使用 && 确保值为真时才拼接
          const qrContent =
            "https://www.qyjszhgw.com/" +
            (row.carId ? "?carId=" + row.carId : "") +
            (row.carNum ? "&carNum=" + row.carNum : "") +
            (row.carType ? "&carType=" + row.carType : "");
          console.log(qrContent);
          console.log(qrContent);
          // 用 canvas 生成二维码并在底部添加文字
          const canvas = document.createElement("canvas");
          const qrSize = 200;
          const textHeight = 30;
          const totalHeight = qrSize + textHeight;
          canvas.width = qrSize;
          canvas.height = totalHeight;
          await QRCode.toCanvas(canvas, qrContent, {
            width: qrSize,
            margin: 1,
          });
          // 在二维码下方绘制车牌号文字
          const ctx = canvas.getContext("2d");
          // 扩展画布高度以容纳文字
          const imageData = ctx.getImageData(0, 0, qrSize, qrSize);
          canvas.height = totalHeight;
          ctx.putImageData(imageData, 0, 0);
          // 白色背景
          ctx.fillStyle = "#ffffff";
          ctx.fillRect(0, qrSize, qrSize, textHeight);
          // 绘制文字
          ctx.fillStyle = "#333333";
          ctx.font = "bold 16px 'Microsoft YaHei', sans-serif";
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText(row.carNum, qrSize / 2, qrSize + textHeight / 2);
          const dataUrl = canvas.toDataURL("image/png");
          this.$set(this.dataList[i], "qrcodeUrl", dataUrl);
        } else {
          this.$set(this.dataList[i], "qrcodeUrl", null);
        }
      }
    },
    downloadQRCode(row) {
      if (!row.qrcodeUrl) {
        this.$message.error("二维码不存在");
        return;
      }
      const link = document.createElement("a");
      link.href = row.qrcodeUrl;
      link.download = `${row.carNum || "车辆二维码"}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    openAddNewCarInfoDialog() {
      this.addNewCarInfoDialogVisible = true;
    },
    addCarInfoDialogClose() {
      this.addNewCarInfoDialogVisible = false;
    },
    getUsageStatusTagString(value) {
      const statusArray = ["success", "warning", "danger"];
      return statusArray[value] || "unknown";
    },
    delCarInfoEvent(obj) {
      let item = {
        id: obj.carId,
      };
      carDelete(item).then((result) => {
        if (result.data.code === 200) {
          this.$message({ message: "删除成功", type: "success" });
          this.getCarListPage();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    openCarRecordsInfoDialog(obj) {
      this.selectCarRecordsInfo = obj;
      this.carRecordsInfoDialogVisible = true;
    },

    carRecordsInfoDialogClose() {
      this.carRecordsInfoDialogVisible = false;
      this.getCarListPage();
    },

    openUpdateCarInfoDialog(obj) {
      this.selectCarUpdateInfo = obj;
      this.updateCarInfoDialogVisible = true;
      // console.log("mars",obj)
    },
    updateCarInfoDialogClose() {
      this.updateCarInfoDialogVisible = false;
      this.getCarListPage();
    },
    openViolationViolationnfoDialog(obj) {
      this.selectCarViolationInfo = obj;
      this.openViolationInfoDialogVisible = true;
    },
    violationInfoDialogClose() {
      this.openViolationInfoDialogVisible = false;
      this.getCarListPage();
    },
    openCarMaintenanceInfoDialog(obj) {
      this.selectCarMaintenanceInfo = obj;
      this.openCarMaintenanceInfoDialogVisible = true;
    },
    carMaintenanceInfoDialogClose() {
      this.openCarMaintenanceInfoDialogVisible = false;
      this.getCarListPage();
    },

    openCarInsuranceInfoDialog(obj) {
      this.selectCarInsuranceInfo = obj;
      this.openCarInsuranceInfoDialogVisible = true;
    },
    carInsuranceInfoDialogClose() {
      this.openCarInsuranceInfoDialogVisible = false;
      this.getCarListPage();
    },
    openMap(carNo) {
      let req = {
        carNum: "",
        urlType: 2,
        date: "",
        isQueryByTime: 0,
        timeFrom: "",
        timeTo: "",
        vkey: carNo,
      };

      urlDirect(req).then((result) => {
        if (result.data.code === 200) {
          // console.log(result.data.data)
          window.open(result.data.data);
        } else {
          this.$message.error(result.data.message);
        }
      });
    },
  },
  created() {
    this.getDictList();
    this.getOrganizatonData();
    this.getGroupInfo();
    this.getCarListPage();
  },
};
</script>
